// extracted by mini-css-extract-plugin
export default {"cls1":"Z7cQioMb3ZhQD1FN1gRM","cls2":"hdEabJrImsTaXtugP00x Z7cQioMb3ZhQD1FN1gRM"};